import React from "react";
import { Route, Switch, useRouteMatch, useLocation } from "react-router-dom";

import NewOrders from "../Pages/orders/newOrders/NewOrders";
import HeaderRouter from "./HeaderRouter";
import Employees from "../Pages/system-management/Employees/Employees";

import { CssBaseline } from "@material-ui/core";
import ReadyOrders from "../Pages/orders/readyOrders/ReadyOrders";
import Transactions from "../Pages/orders/transactions/Transactions";
import History from "../Pages/orders/history/History";
import { ordersStyles } from "../styles/ordersStyles";
import UsersGroup from "../Pages/system-management/user-groups/UsersGroup";
import NewGroup from "../Pages/system-management/user-groups/NewGroup";
import Accessbilities from "../Pages/system-management/accessbilities/Accessbilities";
import NewEmployee from "../Pages/system-management/Employees/NewEmployee";
import Profile from "../Pages/profile/Profile";
import PageNotFound from "./404";
import Base from "./base";

const MainBody = () => {
  const { path } = useRouteMatch();
  const classes = ordersStyles();
  const location = useLocation();

  let Routes = [
    { path: "profile", comp: Profile, exact: false },
    { path: "", comp: Base, exact: true },
    { path: "orders/newOrders", comp: NewOrders, exact: true },

    { path: "orders/readyToSend", comp: ReadyOrders, exact: true },
    { path: "orders/history", comp: History, exact: true },
    { path: "orders/transactions", comp: Transactions, exact: true },
    { path: "system-manegment/employees", comp: Employees, exact: true },
    {
      path: "system-manegment/employees/newEmployee",
      comp: NewEmployee,
      exact: true,
    },
    {
      path: "system-manegment/users-group",
      comp: UsersGroup,
      exact: true,
    },
    {
      path: "system-manegment/users-group/new-group",
      comp: NewGroup,
      exact: true,
    },
    {
      path: "system-manegment/accessibilities",
      comp: Accessbilities,
      exact: false,
    },
  ];

  return (
    <>
      <CssBaseline />
      <div className={classes.orderRoot} style={{ flexGrow: 0.05 }}>
        <HeaderRouter />
      </div>

      <div className={classes.orderRoot} style={{ flexGrow: 1 }}>
        <Switch location={location} key={location.key}>
          {Routes.map((item, i) => {
            return (
              <Route key={i} exact={item.exact} path={`${path}${item.path}`}>
                {<item.comp />}
              </Route>
            );
          })}
          <Route component={PageNotFound} path="*" />
        </Switch>
      </div>
    </>
  );
};

export default MainBody;
